// extracted by mini-css-extract-plugin
var _1 = "tjs-chart-panel__axis";
var _2 = "tjs-chart-panel__btn";
var _3 = "tjs-chart-panel__btn--close-chart-panel tjs-_buttons__btn";
var _4 = "tjs-chart-panel__btn--close-chart-panel tjs-_buttons__btn";
var _5 = "tjs-chart-panel__chart";
var _6 = "tjs-chart-panel__chart-panel";
var _7 = "tjs-chart-panel__chart-panel";
var _8 = "tjs-chart-panel__colors";
var _9 = "tjs-chart-panel__header";
var _a = "tjs-chart-panel__holder";
var _b = "tjs-chart-panel__inner";
var _c = "tjs-chart-panel__section-label tjs-_labels__label";
var _d = "tjs-chart-panel__section-label tjs-_labels__label";
export { _1 as "axis", _2 as "btn", _3 as "btn--close-chart-panel", _4 as "btnCloseChartPanel", _5 as "chart", _6 as "chart-panel", _7 as "chartPanel", _8 as "colors", _9 as "header", _a as "holder", _b as "inner", _c as "section-label", _d as "sectionLabel" }
export default { "axis": _1, "btn": _2, "btn--close-chart-panel": _3, "btnCloseChartPanel": _4, "chart": _5, "chart-panel": _6, "chartPanel": _7, "colors": _8, "header": _9, "holder": _a, "inner": _b, "section-label": _c, "sectionLabel": _d }
